
import {Component, Vue, Prop} from 'vue-property-decorator';
import {statisticsApi} from '@/api';
@Component
export default class DataOverview extends Vue {
    activeKey = 'CourseOverview';
    tabsList = [
        {text: '课程数据总览', key: 'CourseOverview'},
        {text: '作品数据总览', key: 'WorkOverview'},
        {text: '账户数据总览', key: 'AccountOverview'}
    ];
    overViewObjectCount: any = {CourseOverview: {}, WorkOverview: {}, AccountOverview: {}};
    overviewObject = {
        CourseOverview: [
            {text: '课程资源', key: 'schoolCourseCount', unit: '门', desc: '课程资源为学校向暗物智AI科创平台采购的课程总数量。'},
            {text: '授权课程', key: 'classcourseCount', unit: '门', desc: '授权课程为学校将采购的课程关联到各个班级的课程总数量。'},
            {text: '上课中', key: 'studyingCourseCount', unit: '门', desc: '当前关联到各个班级的课程中，正在上课的课程总门数。'},
            {text: '待开始', key: 'noStartCourseCount', unit: '门', desc: '当前关联到各个班级的课程中，待开始的课程总门数。'},
            {text: '已结束', key: 'endCourseCount', unit: '门', desc: '当前关联到各个班级的课程中，已结束的课程总门数。'}
        ],
        WorkOverview: [
            {text: '提交总数', key: 'commitWorkCount', unit: '份', desc: '当前所有课程关联班级中，已提交的作品总数。'},
            {text: '提交率', key: 'commitWorkRate', unit: '%', desc: '当前所有课程关联班级中，已提交的作品总数除于应交作品总数的结果。'},
            {
                text: '批改总数',
                key: 'correctWorkCount',
                unit: '份',
                desc: '当前所有课程关联班级中，已批改的作品总数除于提交的作品总数的结果。'
            },
            {text: '批改率', key: 'correctWorkRate', unit: '%', desc: '当前所有课程关联班级中，已批改的作品总数除于提交的作品总数的结果。'},
            {
                text: '优秀作品总数',
                key: 'excellentWorkCount',
                unit: '份',
                desc: '当前所有课程关联班级中，作品结果已发布且星级为4.5星的作品总数。'
            },
            {
                text: '优秀率',
                key: 'excellentWorkRate',
                unit: '%',
                desc: '当前所有课程关联班级中，作品结果已发布且星级为4.5星的作品总数占已批改且已发布的作品总数的比例。'
            }
        ],
        AccountOverview: [
            {text: '教师人数', key: 'teacherCount', unit: '人', desc: ''},
            {text: '学生人数', key: 'studentCount', unit: '人', desc: ''},
            {
                text: '学校管理员',
                key: 'schoolAdminCount',
                unit: '人',
                desc: '当前学校管理端的管理员个数，以及授权教师具备管理员权限的总人数。'
            },
            {text: '班级数', key: 'classCount', unit: '个', desc: ''}
        ]
    };
    boxStyle = [
        {bar: '#47D075', bgc: '#F3FFF5'},
        {bar: '#1456ED', bgc: '#F2F8FF'},
        {bar: '#805CF2', bgc: '#F5F1FF'},
        {bar: '#FF5637', bgc: '#FFF8E6'},
        {bar: '#FF5637', bgc: '#FFF4F2'},
        {bar: '#b9b9bb', bgc: '#F7F8FA'}
    ];
    tabChange(key: string) {
        this.activeKey = key;
        this.getCurrentTabData();
    }

    getCurrentTabData() {
        // @ts-ignore
        statisticsApi[`get${this.activeKey}`]({
            context: this,
            success: (data: any, parameters: any) => {
                if (data.code === 0) {
                    this.overViewObjectCount[this.activeKey] = data.data;
                }
            }
        });
    }

    created() {
        this.getCurrentTabData();
    }
}
